//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CAvatar from "@/components/CAvatar.vue";
import TransitionFade from "@/components/TransitionFade.vue";
import { PRODUCTID, setUserInfo } from "@/utils/auth";
import SysUtils from "@/utils/sysUtils";
import OrderService from "@/api/orderService";
import UserService from "@/api/userService";
import ProductService from "@/api/productService";
import WxService from "@/api/wxService";
import WxJsSdk from "@/utils/wxJsSdk";

export default {
  data() {
    return {
      btnDisabled: false, // 控制支付按钮是否可点击
      inputNum: "113.000",
      defaultNum: "113.000",
      totalPrice: "14464.00",
      minBuy: 113,
      productVipPrice: 128,
      shareImg: require("../../assets/logo.png"),
      showBirthday: false, // 是否用户生日
    };
  },
  computed: {
    banner: function () {
      return require("../../assets/theme_yellow/banner2.jpg");
    },
    minusIcon: function () {
      if (this.$root.themeType == "yellow") {
        return require("../../assets/theme_yellow/minus.png");
      } else {
        return require("../../assets/theme_black/minus.png");
      }
    },
    plusIcon: function () {
      if (this.$root.themeType == "yellow") {
        return require("../../assets/theme_yellow/plus.png");
      } else {
        return require("../../assets/theme_black/plus.png");
      }
    },
    buyIcon: function () {
      if (this.$root.themeType == "yellow") {
        return require("../../assets/theme_yellow/buy.png");
      } else {
        return require("../../assets/theme_black/buy.png");
      }
    },
  },
  mounted() {
    if (SysUtils.isWeiXin()) {
      let url = window.location.href.split("#")[0];
      // 获取微信config配置，配置支付和分享环境配置
      WxService.getConfig(encodeURIComponent(url))
        .then((res) => {
          if (res) {
            this.$wechat.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.appId, // 必填，公众号的唯一标识
              timestamp: res.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.nonceStr, // 必填，生成签名的随机串
              signature: res.signature, // 必填，签名
              jsApiList: ["chooseWXPay", "updateAppMessageShareData", "updateTimelineShareData", "onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ"], // 必填，需要使用的JS接口列表
            });
            let link = window.location.origin + window.location.pathname;
            let title = "营养美学";
            let des = "胶原蛋白弹性蛋白饮料";
            let imgUrl = this.shareImg;
            this.$wechat.ready(function () {
              // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
              WxJsSdk.handleWxShare(title, des, link, imgUrl);
            });
            this.$wechat.error(function (res) {
              // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
              console.log(res);
            });
          }
        })
        .catch((err) => {
          this.$vux.toast.text(err.msg);
        });
    }

    this.getUserInfo();
  },
  methods: {
    /**
     * 处理输入内容，限制小数点后三位
     * 不输入数字默认
     */
    handleInput(e) {
      this.inputNum = e.target.value.match(/^\d*(\.?\d{0,3})/g)[0];
      this.defaultNum = this.inputNum;
      if (!this.inputNum) {
        this.defaultNum = this.minBuy;
      }
    },
    /* 聚焦事件，置空inputNum */
    handleFocus() {
      if (this.defaultNum == this.minBuy || this.defaultNum == this.minBuy) {
        this.inputNum = "";
      }
    },
    handleBlur() {
      SysUtils.scrollPageView();

      if (this.defaultNum < this.minBuy) {
        this.$vux.toast.text("最小值为"+this.minBuy);
        this.inputNum = this.minBuy;
        this.defaultNum = this.minBuy;
      } else {
        if (this.inputNum == "") {
          this.inputNum = this.defaultNum;
        } else {
          this.defaultNum = this.inputNum;
        }
      }
      this.calcTotalPrice();
    },
    calcTotalPrice() {
      this.totalPrice = (this.inputNum * this.productVipPrice).toFixed(2);
    },
    /**
     * 点击支付按钮
     * 先生成订单，再调用微信支付操作
     */
    handlePay() {
      // 先禁用支付按钮，避免重复点击
      this.btnDisabled = true;
      if (this.defaultNum >= this.minBuy) {
        OrderService.rushBuy(PRODUCTID, this.inputNum)
          .then((res) => {
            return OrderService.getWxPay(res.data.id);
          })
          .then((res) => {
            this.btnDisabled = false;

            const wxPayData = {
              appId: res.data.appId,
              nonceStr: res.data.nonceStr,
              package: res.data.package,
              paySign: res.data.paySign,
              signType: res.data.signType,
              timestamp: res.data.timeStamp,
            };
            WxJsSdk.chooseWXPay(wxPayData)
              .then((result) => {
                // 如果当前取消了支付
                if (result.errMsg == "chooseWXPay:cancel") {
                  // res.payFlowId
                } else {
                  // 微信支付成功后，进入订单列表
                  this.$router.push({
                    path: "/orderList",
                  });
                }
              })
              .catch((err) => {
                console.log("支付失败:-------------");
                console.log(err);
              });
          })
          .catch((err) => {
            this.btnDisabled = false;
            this.$vux.toast.text(err.msg);
          });
      }
    },
    clickPlus() {
      this.inputNum = Number(this.inputNum) + 1;
      this.calcTotalPrice();
    },
    clickMinus() {
      this.inputNum = Number(this.inputNum) - 1;
      if (this.inputNum <= this.minBuy) {
        this.inputNum = this.minBuy;
      }
      this.calcTotalPrice();
    },
    toInventory() {
      this.$router.push({
        path: "/inventory",
      });
    },
    /**
     * 获取产品信息
     */
    getProductInfo() {
      ProductService.getProductInfo()
        .then((res) => {
          let userInfo = res.data;
          setUserInfo(userInfo);

          this.setTheme(userInfo.starLevel);

          this.inputNum = res.data.minBuy;
          this.defaultNum = res.data.minBuy;
          this.minBuy = res.data.minBuy;
          this.productVipPrice = res.data.productVipPrice;
          this.totalPrice = res.data.minBuy * res.data.productVipPrice;

          let isBirthday = userInfo.birthdayFlag; // 当天是否是该用户的生日 1是0否
          // 查询本地缓存，判断是否查看过生日祝福
          let isBless = localStorage.getItem("BIRTH_BLESS");
          if (isBirthday == 1) {
            // 如果有缓存祝福，说明已经提醒过，不显示祝福
            if (isBless == 1) {
              this.showBirthday = false; // 不显示祝福
            } else {
              this.showBirthday = true; // 显示祝福
              localStorage.setItem("BIRTH_BLESS", 1); // 设置本地缓存，当不是生日的时候清除此缓存
            }
          } else {
            // 不是生日并且有祝福缓存的情况下清除缓存
            if (isBless == 1) {
              localStorage.removeItem("BIRTH_BLESS");
            }
          }
        })
        .catch((err) => {
          this.setTheme(1); // 如果接口失败，也要调用设置主题操作，设为默认样式
          this.$vux.toast.text(err.msg);
        });
    },
    /**
     * 获取用户信息，更新本地用户信息数据
     */
    getUserInfo() {
      UserService.getUserInfo()
        .then((res) => {
          let userInfo = res.data;
          setUserInfo(userInfo);

          this.setTheme(userInfo.starLevel);

          this.inputNum = res.data.minBuy;
          this.defaultNum = res.data.minBuy;
          this.minBuy = res.data.minBuy;
          this.productVipPrice = res.data.productVipPrice;
          this.totalPrice = res.data.minBuy * res.data.productVipPrice;

          let isBirthday = userInfo.birthdayFlag; // 当天是否是该用户的生日 1是0否
          // 查询本地缓存，判断是否查看过生日祝福
          let isBless = localStorage.getItem("BIRTH_BLESS");
          if (isBirthday == 1) {
            // 如果有缓存祝福，说明已经提醒过，不显示祝福
            if (isBless == 1) {
              this.showBirthday = false; // 不显示祝福
            } else {
              this.showBirthday = true; // 显示祝福
              localStorage.setItem("BIRTH_BLESS", 1); // 设置本地缓存，当不是生日的时候清除此缓存
            }
          } else {
            // 不是生日并且有祝福缓存的情况下清除缓存
            if (isBless == 1) {
              localStorage.removeItem("BIRTH_BLESS");
            }
          }
        })
        .catch((err) => {
          this.setTheme(1); // 如果接口失败，也要调用设置主题操作，设为默认样式
          this.$vux.toast.text(err.msg);
        });
    },
    /**
     * 设置主题
     */
    setTheme(starLevel) {
      SysUtils.setThemeType(starLevel, this); // 设置主题

      // 单独设置背景色
      document.documentElement.style.backgroundColor = "#EFEBE2";
    },
  },
  components: {
    CAvatar,
    TransitionFade,
  },
  destroyed() {
    // 单独设置背景色
    if (this.$root.themeType == "yellow") {
      document.documentElement.style.backgroundColor = "#fff";
    } else {
      document.documentElement.style.backgroundColor = "#242626";
    }
  },
};



// WEBPACK FOOTER //
// ./src/views/robbing/robbing.vue